module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Da-Ea.145f0fac.png";